import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 그리드 공통
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface 현재 오픈된 메뉴의 메뉴 정보 (CD_MENU, NM_MENU, CD_MODULE...)

interface Props {
  Menuprops: menuInfo;
}
interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_PRD_BAS_REG_030 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Variable
  const gridApiRef = useRef<any>(null); // 그리드 Reference 변수
  const { userInfo } = global(); // Login user 정보
  const searchRef = useRef<any>(null);
  //#endregion

  //#region Components useState
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);

  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any[]>([]); // gridApiRefH 컬럼 설정 관련
  const [dataSource, setDataSource] = useState<any>(); // gridApiRefH datasource 관련
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource([]);
      try {
        const rtn: any = await getInitFormData();

        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums(rtn.grid.grid1); // H그리드 항목 설정
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridApiRef.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));
  //#endregion

  //#region onSearch
  const onSearch = async () => {
    const modifiedRows = gridApiRef.current.getChange();
    if (modifiedRows.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const param = {
        id: "sn_prd_bas_reg_030_01",
        params: searchRef.current.getFormdata(),
      };
      setDataSource([]);
      const data: any = await fnGetDataSet(param);
      setDataSource(data[0]);

      if (data[0] && data[0].length > 0) {
        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        gridApiRef.current.selectAndFocusRow(0);
        setGridFocus(true);
      }
      gridApiRef.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onInsert
  const onInsert = async () => {
    try {
      const newRow = {};
      gridApiRef.current?.addRow(newRow);
      setTimeout(() => {
        gridApiRef.current.api.setFocusedCell(
          gridApiRef.current.api.getDisplayedRowCount() - 1,
          "cd_wc"
        );
      }, 50);
    } catch (error: any) {}
  };
  //#endregion

  //#region onBeforeAddRow
  const onBeforeAddRow = (newRow: RowData): boolean => {
    try {
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        yn_use: "Y",
      };
      Object.assign(newRow, updatedRow);
      return true;
    } catch (error: any) {
      return false;
    }
  };
  //#endregion

  //#region onDelete
  const onDelete = async () => {
    gridApiRef.current?.deleteSelectedRows();
  };
  //#endregion

  //#region onSave
  const onSave = async () => {
    try {
      gridApiRef.current.api.stopEditing();
      const requiredValuesCheckH = gridApiRef.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      const changesRow = gridApiRef.current.getChange();
      if (changesRow.modifiedRowcount === 0) {
        await showDialog("alter", "변경 된 내용이 없습니다.");
        return;
      }
      const SaveData = {
        prd_wc: changesRow,
      };
      // 저장 API 호출
      await fnSave("SN_PRD_BAS_REG_030_SAVE_01", SaveData);

      // 성공적으로 저장된 후 초기화
      gridApiRef.current.resetUpdate();
    } catch (error: any) {}
  };
  //#endregion

  //#region UI
  return (
    <div style={{ height: "100%" }}>
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div style={{ height: "calc(90%)" }}>
        <SnGrid
          
          seq={1}
          ref={gridApiRef}
          enableAddRow={true}
          columnConfig={columns} // 컬럼 설정 전달
          rowData={dataSource}
          enableExternalChart={false}
          isEditable={true}
          // rowSelection="multiple"
          rowSelection="single"
          cellSelection={false}
          onBeforeAddRow={onBeforeAddRow}
        />
      </div>
    </div>
  );
  //#endregion
});
export default SN_PRD_BAS_REG_030;
